export default __webpack_public_path__ + "static/media/combat_ability.32fec4ae.png";